export type SubscriptionStatus = 'trial' | 'active' | 'past_due' | 'grace_period' | 'suspended' | 'cancelled';
export type LicenseStatus = 'paid' | 'pending' | 'grace' | 'suspended' | 'exempt';

export interface BillingPlan {
  name: string;
  price: number;
  color: string;
  icon: string;
}

export interface Payment {
  id: number;
  amount: number;
  date: string;
  method: string;
  status: 'completed' | 'pending' | 'failed';
  invoiceId: string;
}

export interface Invoice {
  id: string;
  radioName: string;
  frequency: string;
  plan: string;
  amount: number;
  issueDate: string;
  dueDate: string;
  status: 'paid' | 'pending' | 'overdue';
  paymentDate: string | null;
}

export interface SubscriptionExtra {
  name: string;
  price: number;
  icon: string;
}

export interface Subscription {
  id: number;
  radioName: string;
  frequency: string;
  plan: string;
  planPrice: number;
  status: SubscriptionStatus;
  monthlyPrice: number;
  startedAt: string;
  nextBilling: string;
  cancelledAt: string | null;
  payments: Payment[];
  contractTerms: string;
  contractStartDate: string;
  contractEndDate: string;
  annualLicenseStatus: LicenseStatus;
  annualLicenseExpiry: string;
  extras: SubscriptionExtra[];
  domainPremium: boolean;
  lastInvoiceId: string | null;
  lastInvoiceDate: string | null;
  lastPaymentId: string | null;
  lastPaymentDate: string | null;
  lastPaymentAmount: number | null;
}

export const subscriptions: Subscription[] = [
  {
    id: 1, radioName: 'Radio Nueva Actitud', frequency: '87.90 RFW', plan: 'Premium', planPrice: 49, status: 'active', monthlyPrice: 49, startedAt: '2025-03-15', nextBilling: '2026-07-15', cancelledAt: null,
    contractTerms: 'Pago mensual automático. Renovación anual con ajuste del 5%. Cancelación con 30 días de preaviso.',
    contractStartDate: '2025-03-15', contractEndDate: '2027-03-15',
    annualLicenseStatus: 'paid', annualLicenseExpiry: '2027-03-15',
    extras: [{ name: 'Dominio Premium .radio', price: 29, icon: 'ri-global-line' }, { name: 'App Móvil Personalizada', price: 19, icon: 'ri-smartphone-line' }],
    domainPremium: true, lastInvoiceId: 'INV-0601', lastInvoiceDate: '2026-06-15', lastPaymentId: 'PAY-104', lastPaymentDate: '2026-06-15', lastPaymentAmount: 49,
    payments: [
      { id: 101, amount: 49, date: '2026-06-15', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0601' },
      { id: 102, amount: 49, date: '2026-05-15', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0501' },
      { id: 103, amount: 49, date: '2026-04-15', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0401' },
      { id: 104, amount: 49, date: '2026-03-15', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0301' },
    ],
  },
  {
    id: 2, radioName: 'Stereo Visión', frequency: '94.70 RFW', plan: 'Premium', planPrice: 49, status: 'active', monthlyPrice: 49, startedAt: '2025-01-10', nextBilling: '2026-07-10', cancelledAt: null,
    contractTerms: 'Pago mensual automático. Renovación anual con ajuste del 5%. Cancelación con 30 días de preaviso.',
    contractStartDate: '2025-01-10', contractEndDate: '2027-01-10',
    annualLicenseStatus: 'paid', annualLicenseExpiry: '2027-01-10',
    extras: [{ name: 'Dominio Premium .radio', price: 29, icon: 'ri-global-line' }],
    domainPremium: true, lastInvoiceId: 'INV-0610', lastInvoiceDate: '2026-06-10', lastPaymentId: 'PAY-203', lastPaymentDate: '2026-06-10', lastPaymentAmount: 49,
    payments: [
      { id: 201, amount: 49, date: '2026-06-10', method: 'Transferencia', status: 'completed', invoiceId: 'INV-0610' },
      { id: 202, amount: 49, date: '2026-05-10', method: 'Transferencia', status: 'completed', invoiceId: 'INV-0510' },
      { id: 203, amount: 49, date: '2026-04-10', method: 'Transferencia', status: 'completed', invoiceId: 'INV-0410' },
    ],
  },
  {
    id: 3, radioName: 'TechBeats', frequency: '88.50 RFW', plan: 'Pro', planPrice: 19, status: 'trial', monthlyPrice: 0, startedAt: '2026-06-28', nextBilling: '2026-07-12', cancelledAt: null,
    contractTerms: 'Período de prueba 14 días sin cargo. Al finalizar, facturación mensual automática de $19.',
    contractStartDate: '2026-06-28', contractEndDate: '2026-07-12',
    annualLicenseStatus: 'pending', annualLicenseExpiry: '2026-07-20',
    extras: [],
    domainPremium: false, lastInvoiceId: null, lastInvoiceDate: null, lastPaymentId: null, lastPaymentDate: null, lastPaymentAmount: null,
    payments: [],
  },
  {
    id: 4, radioName: 'Radio Élite Digital', frequency: '91.30 RFW', plan: 'Business', planPrice: 39, status: 'active', monthlyPrice: 39, startedAt: '2025-08-01', nextBilling: '2026-07-01', cancelledAt: null,
    contractTerms: 'Pago mensual automático. Incluye soporte prioritario y API dedicada.',
    contractStartDate: '2025-08-01', contractEndDate: '2026-08-01',
    annualLicenseStatus: 'grace', annualLicenseExpiry: '2026-05-31',
    extras: [{ name: 'API Dedicada', price: 15, icon: 'ri-terminal-box-line' }, { name: 'Dominio Premium .radio', price: 29, icon: 'ri-global-line' }],
    domainPremium: true, lastInvoiceId: 'INV-0601b', lastInvoiceDate: '2026-06-01', lastPaymentId: 'PAY-401', lastPaymentDate: '2026-06-01', lastPaymentAmount: 39,
    payments: [
      { id: 401, amount: 39, date: '2026-06-01', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0601b' },
      { id: 402, amount: 39, date: '2026-05-01', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0501b' },
    ],
  },
  {
    id: 5, radioName: 'Radio Deportiva Total', frequency: '101.70 RFW', plan: 'Pro', planPrice: 19, status: 'past_due', monthlyPrice: 19, startedAt: '2026-03-01', nextBilling: '2026-06-01', cancelledAt: null,
    contractTerms: 'Pago mensual automático. Corte por falta de pago a los 15 días de vencimiento.',
    contractStartDate: '2026-03-01', contractEndDate: '2027-03-01',
    annualLicenseStatus: 'paid', annualLicenseExpiry: '2027-03-01',
    extras: [{ name: 'Dominio Premium .radio', price: 29, icon: 'ri-global-line' }],
    domainPremium: true, lastInvoiceId: 'INV-0601c', lastInvoiceDate: '2026-06-01', lastPaymentId: 'PAY-502', lastPaymentDate: '2026-05-01', lastPaymentAmount: 19,
    payments: [
      { id: 501, amount: 19, date: '2026-06-01', method: 'Tarjeta', status: 'failed', invoiceId: 'INV-0601c' },
      { id: 502, amount: 19, date: '2026-05-01', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0501c' },
      { id: 503, amount: 19, date: '2026-04-01', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0401c' },
    ],
  },
  {
    id: 6, radioName: 'Radio Urbana 101', frequency: '103.50 RFW', plan: 'Premium', planPrice: 49, status: 'active', monthlyPrice: 49, startedAt: '2025-04-01', nextBilling: '2026-07-01', cancelledAt: null,
    contractTerms: 'Pago mensual automático. Descuento del 10% por pago anual adelantado.',
    contractStartDate: '2025-04-01', contractEndDate: '2027-04-01',
    annualLicenseStatus: 'paid', annualLicenseExpiry: '2027-04-01',
    extras: [{ name: 'App Móvil Personalizada', price: 19, icon: 'ri-smartphone-line' }],
    domainPremium: true, lastInvoiceId: 'INV-0601d', lastInvoiceDate: '2026-06-01', lastPaymentId: 'PAY-601', lastPaymentDate: '2026-06-01', lastPaymentAmount: 49,
    payments: [
      { id: 601, amount: 49, date: '2026-06-01', method: 'Transferencia', status: 'completed', invoiceId: 'INV-0601d' },
      { id: 602, amount: 49, date: '2026-05-01', method: 'Transferencia', status: 'completed', invoiceId: 'INV-0501d' },
      { id: 603, amount: 49, date: '2026-04-01', method: 'Transferencia', status: 'completed', invoiceId: 'INV-0401d' },
      { id: 604, amount: 49, date: '2026-03-01', method: 'Transferencia', status: 'completed', invoiceId: 'INV-0301d' },
    ],
  },
  {
    id: 7, radioName: 'Clásica FM', frequency: '99.10 RFW', plan: 'Starter', planPrice: 0, status: 'active', monthlyPrice: 0, startedAt: '2025-12-10', nextBilling: '—', cancelledAt: null,
    contractTerms: 'Plan gratuito sin costo. Sin contrato de permanencia.',
    contractStartDate: '2025-12-10', contractEndDate: '—',
    annualLicenseStatus: 'exempt', annualLicenseExpiry: '—',
    extras: [],
    domainPremium: false, lastInvoiceId: null, lastInvoiceDate: null, lastPaymentId: null, lastPaymentDate: null, lastPaymentAmount: null,
    payments: [],
  },
  {
    id: 8, radioName: 'Radio Marítima', frequency: '89.50 RFW', plan: 'Starter', planPrice: 0, status: 'grace_period', monthlyPrice: 0, startedAt: '2026-04-20', nextBilling: '—', cancelledAt: null,
    contractTerms: 'Plan gratuito. Migración a Básico pendiente. Período de gracia de 30 días.',
    contractStartDate: '2026-04-20', contractEndDate: '—',
    annualLicenseStatus: 'exempt', annualLicenseExpiry: '—',
    extras: [],
    domainPremium: false, lastInvoiceId: null, lastInvoiceDate: null, lastPaymentId: null, lastPaymentDate: null, lastPaymentAmount: null,
    payments: [],
  },
  {
    id: 9, radioName: 'Jazz Club Radio', frequency: '92.80 RFW', plan: 'Pro', planPrice: 19, status: 'cancelled', monthlyPrice: 19, startedAt: '2025-09-12', nextBilling: '—', cancelledAt: '2026-05-20',
    contractTerms: 'Cancelado por el cliente. Sin penalidad por cumplimiento de ciclo mínimo.',
    contractStartDate: '2025-09-12', contractEndDate: '2026-05-20',
    annualLicenseStatus: 'suspended', annualLicenseExpiry: '2026-05-20',
    extras: [],
    domainPremium: false, lastInvoiceId: 'INV-0512', lastInvoiceDate: '2026-05-12', lastPaymentId: 'PAY-901', lastPaymentDate: '2026-05-12', lastPaymentAmount: 19,
    payments: [
      { id: 901, amount: 19, date: '2026-05-12', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0512' },
      { id: 902, amount: 19, date: '2026-04-12', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0412' },
      { id: 903, amount: 19, date: '2026-03-12', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0312' },
    ],
  },
  {
    id: 10, radioName: 'Radio Folclor Andino', frequency: '107.90 RFW', plan: 'Básico', planPrice: 9, status: 'suspended', monthlyPrice: 9, startedAt: '2026-01-05', nextBilling: '—', cancelledAt: null,
    contractTerms: 'Suspendido por falta de pago. Reactivación disponible abonando deuda pendiente.',
    contractStartDate: '2026-01-05', contractEndDate: '2027-01-05',
    annualLicenseStatus: 'suspended', annualLicenseExpiry: '2026-04-05',
    extras: [],
    domainPremium: false, lastInvoiceId: 'INV-0505', lastInvoiceDate: '2026-05-05', lastPaymentId: 'PAY-1001', lastPaymentDate: '2026-04-05', lastPaymentAmount: 9,
    payments: [
      { id: 1001, amount: 9, date: '2026-04-05', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0405' },
      { id: 1002, amount: 9, date: '2026-03-05', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0305' },
      { id: 1003, amount: 9, date: '2026-05-05', method: 'Tarjeta', status: 'failed', invoiceId: 'INV-0505' },
    ],
  },
  {
    id: 11, radioName: 'Radio Éxitos TV', frequency: '100.00 RFW', plan: 'Premium', planPrice: 49, status: 'active', monthlyPrice: 49, startedAt: '2025-02-28', nextBilling: '2026-07-28', cancelledAt: null,
    contractTerms: 'Pago mensual automático. Soporte VIP 24/7 incluido.',
    contractStartDate: '2025-02-28', contractEndDate: '2027-02-28',
    annualLicenseStatus: 'pending', annualLicenseExpiry: '2026-08-27',
    extras: [{ name: 'Dominio Premium .radio', price: 29, icon: 'ri-global-line' }, { name: 'App Móvil Personalizada', price: 19, icon: 'ri-smartphone-line' }, { name: 'CDN Acelerado', price: 25, icon: 'ri-speed-up-line' }],
    domainPremium: true, lastInvoiceId: 'INV-0628', lastInvoiceDate: '2026-06-28', lastPaymentId: 'PAY-1101', lastPaymentDate: '2026-06-28', lastPaymentAmount: 49,
    payments: [
      { id: 1101, amount: 49, date: '2026-06-28', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0628' },
      { id: 1102, amount: 49, date: '2026-05-28', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0528' },
    ],
  },
  {
    id: 12, radioName: 'Radio Sonora Digital', frequency: '96.20 RFW', plan: 'Starter', planPrice: 0, status: 'trial', monthlyPrice: 0, startedAt: '2026-07-01', nextBilling: '2026-07-15', cancelledAt: null,
    contractTerms: 'Período de prueba 14 días. Acceso completo al plan Starter sin costo.',
    contractStartDate: '2026-07-01', contractEndDate: '2026-07-15',
    annualLicenseStatus: 'exempt', annualLicenseExpiry: '—',
    extras: [],
    domainPremium: false, lastInvoiceId: null, lastInvoiceDate: null, lastPaymentId: null, lastPaymentDate: null, lastPaymentAmount: null,
    payments: [],
  },
  {
    id: 13, radioName: 'Radio Retro Hits', frequency: '93.10 RFW', plan: 'Business', planPrice: 39, status: 'cancelled', monthlyPrice: 39, startedAt: '2025-07-15', nextBilling: '—', cancelledAt: '2026-04-10',
    contractTerms: 'Cancelado voluntariamente. Datos conservados por 90 días post-cancelación.',
    contractStartDate: '2025-07-15', contractEndDate: '2026-04-10',
    annualLicenseStatus: 'suspended', annualLicenseExpiry: '2026-04-10',
    extras: [{ name: 'CDN Acelerado', price: 25, icon: 'ri-speed-up-line' }],
    domainPremium: true, lastInvoiceId: 'INV-0315', lastInvoiceDate: '2026-03-15', lastPaymentId: 'PAY-1301', lastPaymentDate: '2026-03-15', lastPaymentAmount: 39,
    payments: [
      { id: 1301, amount: 39, date: '2026-03-15', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0315' },
      { id: 1302, amount: 39, date: '2026-02-15', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0215' },
      { id: 1303, amount: 39, date: '2026-01-15', method: 'Tarjeta', status: 'completed', invoiceId: 'INV-0115' },
    ],
  },
  {
    id: 14, radioName: 'Radio Fusión Latina', frequency: '105.30 RFW', plan: 'Starter', planPrice: 0, status: 'cancelled', monthlyPrice: 0, startedAt: '2026-02-10', nextBilling: '—', cancelledAt: '2026-05-30',
    contractTerms: 'Plan gratuito cancelado. Sin obligaciones pendientes.',
    contractStartDate: '2026-02-10', contractEndDate: '2026-05-30',
    annualLicenseStatus: 'exempt', annualLicenseExpiry: '—',
    extras: [],
    domainPremium: false, lastInvoiceId: null, lastInvoiceDate: null, lastPaymentId: null, lastPaymentDate: null, lastPaymentAmount: null,
    payments: [],
  },
  {
    id: 15, radioName: 'Radio Vibra FM', frequency: '90.80 RFW', plan: 'Business', planPrice: 39, status: 'past_due', monthlyPrice: 39, startedAt: '2026-04-08', nextBilling: '2026-06-08', cancelledAt: null,
    contractTerms: 'Pago mensual automático. Dos facturas vencidas. Corte inminente.',
    contractStartDate: '2026-04-08', contractEndDate: '2027-04-08',
    annualLicenseStatus: 'grace', annualLicenseExpiry: '2026-05-08',
    extras: [{ name: 'Dominio Premium .radio', price: 29, icon: 'ri-global-line' }],
    domainPremium: true, lastInvoiceId: 'INV-0608', lastInvoiceDate: '2026-06-08', lastPaymentId: null, lastPaymentDate: null, lastPaymentAmount: null,
    payments: [
      { id: 1501, amount: 39, date: '2026-06-08', method: 'Transferencia', status: 'failed', invoiceId: 'INV-0608' },
      { id: 1502, amount: 39, date: '2026-05-08', method: 'Transferencia', status: 'pending', invoiceId: 'INV-0508' },
    ],
  },
  {
    id: 16, radioName: 'Radio Independencia FM', frequency: '102.10 RFW', plan: 'Básico', planPrice: 9, status: 'grace_period', monthlyPrice: 9, startedAt: '2026-05-01', nextBilling: '2026-07-01', cancelledAt: null,
    contractTerms: 'En período de gracia de 15 días. Pago de $9 pendiente.',
    contractStartDate: '2026-05-01', contractEndDate: '2027-05-01',
    annualLicenseStatus: 'pending', annualLicenseExpiry: '2026-07-01',
    extras: [],
    domainPremium: false, lastInvoiceId: 'INV-0601e', lastInvoiceDate: '2026-06-01', lastPaymentId: null, lastPaymentDate: null, lastPaymentAmount: null,
    payments: [
      { id: 1601, amount: 9, date: '2026-06-01', method: 'Tarjeta', status: 'failed', invoiceId: 'INV-0601e' },
    ],
  },
  {
    id: 17, radioName: 'Radio Andina Digital', frequency: '95.80 RFW', plan: 'Pro', planPrice: 19, status: 'trial', monthlyPrice: 0, startedAt: '2026-07-03', nextBilling: '2026-07-17', cancelledAt: null,
    contractTerms: 'Trial 14 días del plan Pro. Facturación automática al finalizar.',
    contractStartDate: '2026-07-03', contractEndDate: '2026-07-17',
    annualLicenseStatus: 'pending', annualLicenseExpiry: '2026-07-20',
    extras: [],
    domainPremium: false, lastInvoiceId: null, lastInvoiceDate: null, lastPaymentId: null, lastPaymentDate: null, lastPaymentAmount: null,
    payments: [],
  },
  {
    id: 18, radioName: 'Radio Tropicalísima', frequency: '104.60 RFW', plan: 'Premium', planPrice: 49, status: 'active', monthlyPrice: 49, startedAt: '2025-11-20', nextBilling: '2026-07-20', cancelledAt: null,
    contractTerms: 'Pago mensual. Plan Premium con todos los beneficios incluidos.',
    contractStartDate: '2025-11-20', contractEndDate: '2027-11-20',
    annualLicenseStatus: 'paid', annualLicenseExpiry: '2027-11-20',
    extras: [{ name: 'Dominio Premium .radio', price: 29, icon: 'ri-global-line' }, { name: 'App Móvil Personalizada', price: 19, icon: 'ri-smartphone-line' }, { name: 'CDN Acelerado', price: 25, icon: 'ri-speed-up-line' }, { name: 'Soporte VIP 24/7', price: 49, icon: 'ri-headphone-line' }],
    domainPremium: true, lastInvoiceId: 'INV-0620', lastInvoiceDate: '2026-06-20', lastPaymentId: 'PAY-1801', lastPaymentDate: '2026-06-20', lastPaymentAmount: 49,
    payments: [
      { id: 1801, amount: 49, date: '2026-06-20', method: 'Transferencia', status: 'completed', invoiceId: 'INV-0620' },
      { id: 1802, amount: 49, date: '2026-05-20', method: 'Transferencia', status: 'completed', invoiceId: 'INV-0520' },
    ],
  },
];

export const invoices: Invoice[] = [
  { id: 'INV-0601c', radioName: 'Radio Deportiva Total', frequency: '101.70 RFW', plan: 'Pro', amount: 19, issueDate: '2026-06-01', dueDate: '2026-06-15', status: 'overdue', paymentDate: null },
  { id: 'INV-0608', radioName: 'Radio Vibra FM', frequency: '90.80 RFW', plan: 'Business', amount: 39, issueDate: '2026-06-08', dueDate: '2026-06-22', status: 'overdue', paymentDate: null },
  { id: 'INV-0508', radioName: 'Radio Vibra FM', frequency: '90.80 RFW', plan: 'Business', amount: 39, issueDate: '2026-05-08', dueDate: '2026-05-22', status: 'overdue', paymentDate: null },
  { id: 'INV-0505', radioName: 'Radio Folclor Andino', frequency: '107.90 RFW', plan: 'Básico', amount: 9, issueDate: '2026-05-05', dueDate: '2026-05-19', status: 'overdue', paymentDate: null },
  { id: 'INV-0601e', radioName: 'Radio Independencia FM', frequency: '102.10 RFW', plan: 'Básico', amount: 9, issueDate: '2026-06-01', dueDate: '2026-06-15', status: 'overdue', paymentDate: null },
  { id: 'INV-0601', radioName: 'Radio Nueva Actitud', frequency: '87.90 RFW', plan: 'Premium', amount: 49, issueDate: '2026-06-15', dueDate: '2026-06-29', status: 'pending', paymentDate: null },
  { id: 'INV-0610', radioName: 'Stereo Visión', frequency: '94.70 RFW', plan: 'Premium', amount: 49, issueDate: '2026-06-10', dueDate: '2026-06-24', status: 'pending', paymentDate: null },
  { id: 'INV-0620', radioName: 'Radio Tropicalísima', frequency: '104.60 RFW', plan: 'Premium', amount: 49, issueDate: '2026-06-20', dueDate: '2026-07-04', status: 'pending', paymentDate: null },
];

export const statusLabels: Record<string, string> = {
  trial: 'Trial',
  active: 'Activa',
  past_due: 'Past Due',
  grace_period: 'Grace Period',
  suspended: 'Suspendida',
  cancelled: 'Cancelada',
};

export const licenseStatusLabels: Record<string, string> = {
  paid: 'Pagada',
  pending: 'Pendiente',
  grace: 'En Gracia',
  suspended: 'Suspendida',
  exempt: 'Exenta',
};

export const licenseStatusColors: Record<string, string> = {
  paid: 'bg-emerald-100 text-emerald-700',
  pending: 'bg-amber-100 text-amber-700',
  grace: 'bg-sky-100 text-sky-700',
  suspended: 'bg-red-100 text-red-600',
  exempt: 'bg-background-200 text-foreground-500',
};

export const licenseStatusIcons: Record<string, string> = {
  paid: 'ri-check-line',
  pending: 'ri-time-line',
  grace: 'ri-hourglass-line',
  suspended: 'ri-pause-circle-line',
  exempt: 'ri-subtract-line',
};

export function getUniquePlans(subs: Subscription[]): BillingPlan[] {
  const seen = new Map<string, BillingPlan>();
  const planIcons: Record<string, string> = { Starter: 'ri-radio-line', Básico: 'ri-radio-button-line', Pro: 'ri-star-fill', Business: 'ri-briefcase-line', Premium: 'ri-vip-diamond-fill' };
  const planColors: Record<string, string> = { Starter: 'text-foreground-500', Básico: 'text-sky-500', Pro: 'text-amber-500', Business: 'text-emerald-500', Premium: 'text-foreground-800' };
  for (const s of subs) {
    if (!seen.has(s.plan)) {
      seen.set(s.plan, { name: s.plan, price: s.planPrice, icon: planIcons[s.plan] ?? 'ri-stack-line', color: planColors[s.plan] ?? 'text-foreground-500' });
    }
  }
  return Array.from(seen.values()).sort((a, b) => a.price - b.price);
}